import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    BEST_WORKPLACES_FOR_INNOVATORS_PAGE_LOADING() {
      return {
        isLoading: true,
        bestWorkplacesForInnovatorsPage: action.bestWorkplacesForInnovatorsPage
      };
    },
    BEST_WORKPLACES_FOR_INNOVATORS_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'best-workplaces-for-innovators',
        'categoryPage'
      );

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/best-workplaces-for-innovators';
      return {
        isLoading: false,
        data: action.bestWorkplacesForInnovatorsPage,
        ads: adModelData
      };
    },
    BEST_WORKPLACES_FOR_INNOVATORS_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.bestWorkplacesForInnovatorsPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
